<template>
  <v-container fluid class="support-login-page fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card v-if="error" class="auth-card rounded-xl pa-8 text-center" elevation="8">
          <v-icon color="error" size="56" class="mb-4">mdi-alert-circle-outline</v-icon>
          <div class="text-h6 font-weight-bold mb-2">Support Login Failed</div>
          <div class="text-body-2 grey--text mb-6">{{ error }}</div>
          <v-btn color="primary" rounded large elevation="2" class="font-weight-bold text-none" @click="$router.push({name: 'Login'})">
            Go to Login
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
        <v-card v-else class="auth-card rounded-xl pa-8 text-center" elevation="8">
          <v-progress-circular indeterminate color="primary" size="56" width="4" />
          <div class="text-h6 font-weight-bold mt-6 mb-1">Setting up your support session</div>
          <div class="text-body-2 grey--text">Please wait a moment, you're being signed in...</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return { error: null }
  },
  mounted() {
    const { token, school, name, readonly } = this.$route.query

    if (!token || !school) {
      this.error = 'Missing required parameters. Please use the Support button from the partner portal.'
      return
    }

    sessionStorage.authToken = token
    localStorage.school = JSON.stringify({ school_id: school, name: name || '' })
    sessionStorage.utpc = 'Teacher'
    if (readonly) sessionStorage.readonly = '1'

    this.$store.commit('isLoggedIn', true)
    this.$store.dispatch('fetchTokens', school)

    this.$router.push({ name: 'ModuleSelector' })
  }
}
</script>

<style scoped>
.support-login-page {
    min-height: calc(100vh - 64px);
}
</style>
